import React, { useEffect, useMemo, useState } from "react";
import { useSelector } from "react-redux";
import logo from "../../../assets/logos/new_logo_white.png";
import { Link, NavLink } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { CMSOptions } from "../services/website.services";
import { MENU_LOCATION } from "../../../utils/Constants";

const WebsiteFooter = () => {
  const [getGlobalData, setGlobalData] = useState({});
  const [dynamicOptions, setDynamicOptions] = useState([]);
  const myGlobalData = useSelector((state) => state.globalData?.data);
  const [refreshOptionsAPI, setRefreshOptionsAPI] = useState(false);

  const { t } = useTranslation();

  useEffect(() => {
    if (myGlobalData) {
      const settingsData = JSON.parse(myGlobalData);
      setGlobalData(settingsData);
    }
  }, [myGlobalData]);

  const handelLogoClick = () => {
    document.querySelector("html, body").scrollTop = 0;
  };

  useEffect(() => {
    CMSOptions(MENU_LOCATION.menu_of_page_footer)
      .then((response) => {
        setDynamicOptions(response?.data);
      })
      .catch((error) => {
        console.log("error of terms&conditions", error);
      });
  }, [refreshOptionsAPI]);

  useMemo(() => {
    document.addEventListener("language_change", function () {
      setRefreshOptionsAPI(!refreshOptionsAPI);
    });
  });

  return (
    <div className="footer-marketing">
      <div className="footer-main">
        <div className="container">
          <div className="row">
            <div className="col-md-3">
              <div className="footer-logo-info">
                <Link className="navbar-brand" to={"/"}>
                  <img src={logo} alt="website logo" onClick={handelLogoClick} />
                </Link>
                <p>{t("web_footer_text")}</p>
              </div>
            </div>
            <div className="col-md-2 ms-auto">
              <h4 className="footer-head">{t("web_footer_company")}</h4>
              <ul className="footer-link">
                {dynamicOptions?.map((item, i) => {
                  if (item.footer_location === "company") {
                    return (
                      <li key={i}>
                        <Link to={`/org-info/${item?.slug}`}>{item?.title}</Link>
                      </li>
                    );
                  }
                  return null;
                })}
              </ul>
            </div>
            <div className="col-md-2">
              <h4 className="footer-head">{t("web_footer_legal")}</h4>
              <ul className="footer-link">
              {dynamicOptions?.map((item, i) => {
                  if (item.footer_location === "legal") {
                    return (
                      <li key={i}>
                        <Link to={`/org-info/${item?.slug}`}>{item?.title}</Link>
                      </li>
                    );
                  }
                  return null;
                })}
              </ul>
            </div>
            <div className="col-md-3">
              <h4 className='footer-head'>{t('web_footer_contact')}</h4>
              {getGlobalData?.social_media_details ?
                <>
                  <ul className="social-icon">
                    {getGlobalData?.social_media_details?.map((item, index) => (
                      <li key={index}>
                        <a href={item?.link} title={item?.title} target="_blank" rel="noreferrer" dangerouslySetInnerHTML={{ __html: (item?.icon) }}>
                        </a>
                      </li>
                    ))
                    }
                  </ul>
                </> : <></>
              }
            </div>
          </div>
        </div>
      </div>
      <div className="copyright-text text-center">{getGlobalData?.copy_right_text}</div>
    </div>
  );
};

export default WebsiteFooter;
